import { Box, Typography } from "@mui/material";
import { useSingleUserControl } from "../../../context/SuperAdmin/SingleUserControlContext";
import { CognitoUser } from "../../../interfaces/SuperAdmin/Others/CognitoUser";
import { FC } from "react";
import { formatFechaWithHour } from "../../../utils/dateFunctions";
import EstadoBadge from "./EstadoBadge";

interface Props {
  user: CognitoUser | undefined;
  type: "provider" | "credentials";
}

const CognitoView: FC<Props> = ({ user, type }) => {
  // En caso de que no exista el usuario
  if (!user) {
    return (
      <Box pt={2} my={8} textAlign="center">
        <Typography fontSize={16} fontStyle="italic">
          No existe un usuario en Cognito con{" "}
          {type === "credentials" ? "credenciales" : "proveedor"} con este
          email.
        </Typography>
      </Box>
    );
  }

  const {
    id,
    name,
    email,
    email_verified,
    created_at,
    updated_at,
    enabled,
    status,
  } = user;

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 2,
        pt: 2,
        fontSize: "14px",
      }}
    >
      {/* ID */}
      <Box>
        <Typography fontWeight="bold">ID</Typography>
        <Typography>{id}</Typography>
      </Box>

      {/* Nombre */}
      <Box>
        <Typography fontWeight="bold">Nombre</Typography>
        <Typography>{name}</Typography>
      </Box>

      {/* Email */}
      <Box>
        <Typography fontWeight="bold">Email</Typography>
        <Typography>{email}</Typography>
      </Box>

      {/* Email Verificado */}
      <Box>
        <Typography fontWeight="bold">Email verificado</Typography>
        <Typography>{email_verified ? "Sí" : "No"}</Typography>
      </Box>

      {/* Permitido */}
      <Box>
        <Typography fontWeight="bold">Estado</Typography>
        <Typography>
          <EstadoBadge estado={enabled ? "success" : "warning"}>
            {enabled ? "Habilitado" : "Deshabilitado"}
          </EstadoBadge>
        </Typography>
      </Box>

      {/* Status */}
      <Box>
        <Typography fontWeight="bold">Status</Typography>
        <Typography>{status}</Typography>
      </Box>

      {/* Fecha de creación */}
      <Box>
        <Typography fontWeight="bold">Fecha de creación</Typography>
        <Typography>{formatFechaWithHour(created_at)}</Typography>
      </Box>

      {/* Última actualización */}
      <Box>
        <Typography fontWeight="bold">Última actualización</Typography>
        <Typography>{formatFechaWithHour(updated_at)}</Typography>
      </Box>
    </Box>
  );
};

export default CognitoView;
